import * as React from 'react';
import * as styles from './phoneButton.css';
import { mergeStyles } from '@cian/utils';
import { Phone } from '../../../../common/components/phone';
import { IOffer, IPhone } from '../../../../types/offer';
import { ICalltrackingPlaceTypes } from '../../../../types/dynamicCalltracking';

interface IPhoneButtonProps {
  offer: IOffer;
  phones: IPhone[];
  isUsedOnTop3Card?: boolean;
  dynamicCalltrackingPlaceType?: ICalltrackingPlaceTypes;
  hasContactLabel?: boolean;

  onPhoneOpened(): void;
}

export const PhoneButton = ({
  isUsedOnTop3Card,
  offer,
  onPhoneOpened,
  phones,
  dynamicCalltrackingPlaceType,
  hasContactLabel= false,
}: IPhoneButtonProps) => (
  <div { ...mergeStyles(
    [styles['phone_button'],
      !isUsedOnTop3Card && styles['phone_button--premium']],
      hasContactLabel && styles['phone_button--with_label'],
  ) }>
    <Phone
      isSimplified
      showWarningMessage={offer.showWarningMessage}
      workTimeInfo={offer.workTimeInfo}
      phones={phones}
      onPhoneOpened={onPhoneOpened}
      offer={offer}
      dynamicCalltrackingPlaceType={dynamicCalltrackingPlaceType}
    />
  </div>
);
